export default "__VITE_ASSET__CrHKWSsm__"